/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realtime_Tracking_Of_Buyer_InInputs */

const en_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time tracking of buyer intent across your portfolio. Identify high-value leads and engagement patterns before they even message you.`)
};

const es_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento en tiempo real de la intención del comprador en todo tu portafolio. Identifica clientes potenciales de alto valor y patrones de interacción incluso antes de que te envíen un mensaje.`)
};

const fr_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi en temps réel des intentions des acheteurs sur l'ensemble de votre portefeuille. Identifiez les prospects à forte valeur ajoutée et les modèles d'engagement avant même qu'ils ne vous contactent.`)
};

const de_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtzeit-Verfolgung der Kaufabsicht in deinem gesamten Portfolio. Identifiziere hochwertige Leads und Interaktionsmuster, noch bevor sie dir eine Nachricht schreiben.`)
};

const ja_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポートフォリオ全体の購入者の意図をリアルタイムで追跡します。メッセージが送られてくる前に、価値の高いリードとエンゲージメントパターンを特定します。`)
};

const zh_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在您的产品组合中实时追踪买家意图。在潜在买家与您联系之前，即可识别高价值线索和互动模式。`)
};

const ar_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع فوري لنوايا المشتري عبر محفظتك. حدد العملاء المحتملين ذوي القيمة العالية وأنماط التفاعل حتى قبل أن يرسلوا لك رسالة.`)
};

const id_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacakan real-time atas niat pembeli di seluruh portofolio Anda. Identifikasi prospek bernilai tinggi dan pola keterlibatan bahkan sebelum mereka mengirimi Anda pesan.`)
};

const it_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento in tempo reale dell'intenzione dell'acquirente in tutto il tuo portafoglio. Identifica lead di alto valore e modelli di coinvolgimento prima ancora che ti inviino un messaggio.`)
};

const ru_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживание намерений покупателей в реальном времени. Выявляйте ценных лидов и паттерны взаимодействия еще до того, как они вам напишут.`)
};

const pt_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhamento em tempo real da intenção do comprador em todo o seu portfólio. Identifique leads de alto valor e padrões de engajamento antes mesmo de eles lhe enviarem uma mensagem.`)
};

const ko_realtime_tracking_of_buyer_in = /** @type {(inputs: Realtime_Tracking_Of_Buyer_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오 전체에 걸친 구매자 의도를 실시간으로 추적합니다. 고객이 메시지를 보내기도 전에 가치 있는 잠재 고객과 참여 패턴을 파악하세요.`)
};

/**
* | output |
* | --- |
* | "Real-time tracking of buyer intent across your portfolio. Identify high-value leads and engagement patterns before they even message you." |
*
* @param {Realtime_Tracking_Of_Buyer_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const realtime_tracking_of_buyer_in = /** @type {((inputs?: Realtime_Tracking_Of_Buyer_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realtime_Tracking_Of_Buyer_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realtime_tracking_of_buyer_in(inputs)
	if (locale === "es") return es_realtime_tracking_of_buyer_in(inputs)
	if (locale === "fr") return fr_realtime_tracking_of_buyer_in(inputs)
	if (locale === "de") return de_realtime_tracking_of_buyer_in(inputs)
	if (locale === "ja") return ja_realtime_tracking_of_buyer_in(inputs)
	if (locale === "zh") return zh_realtime_tracking_of_buyer_in(inputs)
	if (locale === "ar") return ar_realtime_tracking_of_buyer_in(inputs)
	if (locale === "id") return id_realtime_tracking_of_buyer_in(inputs)
	if (locale === "it") return it_realtime_tracking_of_buyer_in(inputs)
	if (locale === "ru") return ru_realtime_tracking_of_buyer_in(inputs)
	if (locale === "pt") return pt_realtime_tracking_of_buyer_in(inputs)
	return ko_realtime_tracking_of_buyer_in(inputs)
});